/**
* @GpsTable.vue
* @Description GPS标签管理组件
* @Author CC
* @Date 2025/09/20
**/

/* HTML */
<template>
    <div class="table-item-box padding-l-none">
        <section style="height: 100%;">
            <!--查询工具条-->
            <el-col style="padding-bottom: 0px;text-align: left;height: 52px;">
                <el-form :inline="true" :model="filters" ref="filters">
                    <el-form-item>
                        查询条件：
                    </el-form-item>
                    <el-form-item prop="did">
                        <el-input v-model="filters.did" placeholder="请输入设备编号" clearable @keyup.enter.native="searchNotice" :style="{width: '300px'}">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="searchNotice"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item style="position: absolute;top: 9px;right: 10px;z-index: 3;margin: 0;">
                        <el-button  type="primary" size="mini" trigger="click" @click="deleteSelect"><i class="el-icon-delete" /> 删除选择消息</el-button>
                    </el-form-item>
                </el-form>
            </el-col>

            <!-- 表格 -->
            <el-table :data="noticeInfos"
                      ref="multipleTable"
                      stripe
                      style="width: 100%;height: calc(100% - 96px);"
                      @row-click="rowHandle"
                      :class="{'table': true, 'no-pagination': false}">
                <el-table-column type="selection" :selectable="checkSelectable"/>
                <el-table-column label="设备编号" min-width="160px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;"
                              :title="'设备编号: ' + scope.row.did">
                            {{scope.row.did}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="生成时间" min-width="160px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;"
                              :title="'时间: ' + $moment(scope.row.dateTime).format('YYYY-MM-DD HH:mm:ss')"
                        >
                            {{$moment(scope.row.dateTime).format('YYYY-MM-DD HH:mm:ss')}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="消息内容" min-width="500px">
                    <template v-slot="scope">
                        <span style="white-space: nowrap;"
                              :title="'消息内容: ' + scope.row.content"
                        >
                            {{scope.row.content}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="120px">
                    <template v-slot="scope">
                        <span style="cursor: pointer;" class="el-icon-delete" type="text" size="mini" @click="()=>{deleteRow(scope.row, scope.$index)}" trigger="click">删除</span>
                    </template>
                </el-table-column>
            </el-table>

        </section>

    </div>
</template>

<script>
// 消息组件
import ApiNotice from '@/request/api-notice'
// 公共函数
import GlobalFun from "@/global/global-function";

export default {
    /**
     * 组件名称
     */
    name: "GpsTagNoticeTable",
    /**
     * 组件引用
     */
    components: {
    },
    /**
     * 数据定义
     * @returns {{}}
     */
    data() {
        return {
            /**
             * @Des 查询条件属性
             * @Auth CC
             * @Date 2025/09/20
             */
            filters: {
                did: '',
            },
            // 基站集合
            noticeInfos:[],
        }
    },
    computed: {
    },
    created(){
    },
    mounted(){
    },
    /**
     * 方法定义
     */
    methods: {
        /**
         * @Description
         * @Param 查询gps标签
         * @Auth CC
         * @Date 2025/09/20
         */
        searchNotice() {
            this.filters.did = this.filters.did.toUpperCase().trim();
            if(this.filters.did == ''){
                return;
            }
            this.$request.postJsonRequest(ApiNotice.findByDidApi, {
                did: this.filters.did,
            }).then(result => {
                // console.log(result);
                this.noticeInfos = [];
                if(result.data && result.data.length > 0){
                    this.noticeInfos = result.data;
                }
            }).catch(error => {
                console.log( "查询标签异常：" + this.$request.error.msg);
            })
        },
        /**
         * @Description
         * @Param 是否选择
         * @Auth CC
         * @Date 2025/09/20
         */
        checkSelectable(row){
            return true;
        },

        /**
         * @Description
         * @Param 处理行
         * @Auth CC
         * @Date 2025/09/20
         */
        rowHandle(row) {
            if (row.checked) {
                row.checked = false;
            } else {
                row.checked = true;
            }
            this.$refs.multipleTable.toggleRowSelection(row, row.checked)
        },

        deleteRow(row, index){
            this.requestDeleteNoticeIds([row.noticeId])
        },
        deleteSelect(){
            let selection = this.$refs.multipleTable.selection;
            if (selection.length == 0) {
                this.$message({
                    message: '请选择要删除的数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }
            let noticeIds = [];
            selection.forEach((row, index) => {
                noticeIds.push(row.noticeId);
            })
            this.requestDeleteNoticeIds(noticeIds);
        },
        requestDeleteDid(){
            this.$confirm(
                '确认要删除消息吗？','询问',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                }
            ).then(_ => {
                this.loading = this.$loading({
                    lock: true,
                    text: '正在删除消息...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$request.postJsonRequest(ApiNotice.deleteByDidsApi, {
                    did: [this.filters.did],
                }).then(result => {
                    this.loading.close();
                    // 删除成功
                    this.$message({
                        message: '删除消息成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.searchNotice();
                }).catch(error => {
                    console.log( "删除消息异常：" + this.$request.error.msg);
                    this.loading.close();
                })
            });
        },
        requestDeleteNoticeIds(noticeIds){
            this.$confirm(
                '确认要删除消息吗？','询问',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    closeOnClickModal : false,
                    type: 'warning'
                }
            ).then(_ => {
                this.loading = this.$loading({
                    lock: true,
                    text: '正在删除消息...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$request.postJsonRequest(ApiNotice.deleteByNoticeIdsApi, {
                    noticeIds: noticeIds,
                }).then(result => {
                    this.loading.close();
                    // 删除成功
                    this.$message({
                        message: '删除消息成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.searchNotice();
                }).catch(error => {
                    console.log( "删除消息异常：" + this.$request.error.msg);
                    this.loading.close();
                })
            });
        }

    }
}
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagNoticeTable.vue